import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

const Banner = ({ children, className }) => {
  const classes = useStyles()

  return <div className={clsx(classes.root, className)}>{children}</div>
}

export default Banner
